//import Integracoes from '../../Integracoes.json';
import * as Actions from '../Actions/MarketplaceActions';

const initialState = {
    error: null,
    info: null,
    warning: null,
    integracoes: null, //Integracoes,
    data: null,
    responseIntegracao: null
};

const MarketplaceReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_INTEGRACAO:
            {
                return {
                    ...state,
                    data: action.payload
                };
            }
        case Actions.GET_INTEGRACOES:
            {
                return {
                    ...state,
                    integracoes: action.payload
                };
            }
        case Actions.MARKETPLACE_INFO:
            {
                return {
                    ...state,
                    info: action.payload
                };
            }
        case Actions.MARKETPLACE_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                };
            }
        case Actions.MARKETPLACE_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        case Actions.MARKETPLACE_RESPONSE_INTEGRACAO:
            {
                return {
                    ...state,
                    responseIntegracao: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

const reducer = MarketplaceReducer;

export default reducer;